import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ProxySettingsState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ProxySettingsState = {
    proxySettings:[],
};


export const proxySettings: Module<ProxySettingsState,RootState> = {
    state,
    getters,
    actions,
    mutations
};
